import React from 'react';
import { ListItem } from '../ListItem';
import { useTranslation } from 'react-i18next';
import { AttachmentItem } from '@klab-berlin/api-sdk/lib/types/responses/Common';
import { notifyBugsnagHandledError } from '../../../utils/bugsnagClient';
import productService from '../../../services/product.service';
import initFileDownload from '../../../components/utils/downloadIFrame';
import formatByteSize from '../../../utils/formatByteSize';
import { zipRetryTime } from '../../../constants';
import { sleep } from '../../../utils/sleep';

const CourseAttachmentsPageItem: React.FC<{ 
    attachment: AttachmentItem
    productId: string 
}> = ({ attachment, productId }) => {
  const { t } = useTranslation();

  const downloadAttachment = async () => {
    const selectedAttachment = {
      contentPath: attachment.contentPath,
      id: attachment.id,
      type: attachment.type,
    };
    try {
      const downloadInfo = 
            await productService.handleProductAttachmentsDownload(productId, [selectedAttachment]);
      if (downloadInfo.link) {
        initFileDownload(downloadInfo.link);
      } else if (downloadInfo.zipID) downloadZip(downloadInfo.zipID);
    } catch (error) {
      notifyBugsnagHandledError(error as Error);
    }
  };

  const downloadZip = async (zipID: string) => {
    let isFinished = false;
    while (!isFinished) {
      try {
        const attachmentZipLink = await productService.getAttachmentZipLink(zipID);
        if (attachmentZipLink.link) {
          initFileDownload(attachmentZipLink.link);
          isFinished = true;
        } else if (attachmentZipLink.error) {
          notifyBugsnagHandledError(new Error(attachmentZipLink.error));
          isFinished = true;
        } else {
          await sleep(zipRetryTime);  // Throttle calls to prevent API / s3-zipper overload.
        }
      } catch (error) {
        notifyBugsnagHandledError(error as Error);
        isFinished = true;
      }
    }
  };

  return (
    <ListItem
      buttonText={t('Download')}
      onButtonClick={downloadAttachment}
      header={attachment.fileName.split('.').at(-1) ?? ''}
      title={attachment.name}
      subHeader={formatByteSize(attachment.fileSize)}
      testId='attachment-item'
    />
  );
};

export default CourseAttachmentsPageItem;
